import { useTranslation } from "react-i18next";
import emailSent from '../assets/email-sent.svg';

interface Props {
  handleBack: () => void;
}

function SignaturesSidebarCompleted(props: Props) {
  const { t } = useTranslation();

  return (

    <div className="flex flex-col w-[360px] h-full bg-white flex-shrink-0 pt-6 px-4 border-l">
      <img src={emailSent} alt="" className="w-full inset-0  object-cover" />

      <div className="text-2xl font-semibold font-gilroy my-4 w-full text-center">
        {t("All done!")}
      </div>
      <div className="text-xs font-semibold text-gray-400 mb-4 w-full text-center">
        {t("Your signature request emails are sent in sequence, after the first is completed the second will be sent and so on.")}
      </div>
      <div className="text-xs font-semibold text-gray-400 mb-4 w-full text-center">
        {t("You can check the status of each recipient on the signatures page.")}
      </div>

      <div className="h-px w-full bg-gray-300 flex-shrink-0 mt-auto" />
      <div className="flex items-center text-sm gap-2 mt-4 mb-4">
        <button className="btn btn-blue border w-full px-0 py-2" onClick={props.handleBack}>Close</button>
      </div>
    </div>
  );

}

export default SignaturesSidebarCompleted;
